import React, {Fragment, memo, useContext, useEffect, useState} from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import { AlertPopup, closeLayerFn, Container, openAlertPopup, openLayerFn } from "../../Layout";
import { SubMenu, SUBS } from "./Input";
import { _O } from "../../../modules/utils";
import { fi } from "date-fns/locale";
import { TargetWeight } from "./WeightList";
import { PostApi1402, PostApi1406 } from "../../../modules/network/padoPost";
import { AppContext } from "../../../components/AppProvider";

import {userHabit} from "../../../modules/utils/UserHabit";
import { NativeAction } from "../../../modules/utils/HandleWs";

const AnalyzeBox = (props) => {
    const { title } = props;
    return(
        <div className="box">
            <div className="tit">{title}</div>
            <div className="inlist-box">
                <ul>
                    <AnalyzeBoxLi color="pu" text='체중' value='55' unit="kg" count='3'/>
                    <AnalyzeBoxLi color="pi" text='골격근량' value='25.8' unit="kg" count='5'/>
                    <AnalyzeBoxLi color="gr" text='체지방량' value='15.8' unit="kg" count='3'/>
                </ul>
            </div>
        </div>
    )
}

const AnalyzeBoxLi = (props) => {
    const { color, text, value, unit, count } = props;

    function test(text, value, sex) {
        switch (text) {
            case '골격근량' :
                if(sex == 1) {
                    if(value < 28) {
                        return 1;
                    } else if(value >= 28 && value < 30) {
                        return 2;
                    } else if(value >= 30 && value < 32) {
                        return 3;
                    } else if(value >= 32 && value < 34) {
                        return 4;
                    } else if(value >= 34 && value < 36) {
                        return 5;
                    } else if(value >= 36 && value < 38) {
                        return 6;
                    } else if(value >= 38 && value < 40) {
                        return 7;
                    } else if(value >= 40 && value < 42) {
                        return 8;
                    } else if(value >= 42) {
                        return 9;
                    }
                } else {
                    if(value < 23.5) {
                        return 1;
                    } else if(value >= 23.5 && value < 25) {
                        return 2;
                    } else if(value >= 25 && value < 26.5) {
                        return 3;
                    } else if(value >= 26.5 && value < 29) {
                        return 4;
                    } else if(value >= 29 && value < 31) {
                        return 5;
                    } else if(value >= 31 && value < 32.5) {
                        return 6;
                    } else if(value >= 32.5 && value < 34) {
                        return 7;
                    } else if(value >= 34 && value < 35.5) {
                        return 8;
                    } else if(value >= 35.5) {
                        return 9;
                    }
                }
            default :
                return 0;
        }
    }

    const percentBar = (count) => {
        const result = [];
        for(let i = 0; i < count; i++) {
            result.push(<i key={i}></i>);
        }
        return result;
    }

    return(
        <li className={"c-" + color}>
            <div className="le-sjt">
                <i></i>
                <span>{text}</span>
                <p><b>{value}</b> {unit}</p>
            </div>
            <div className="cont-boxdots">
                <div className="boxes-horizon">
                    <div className="bx-area">
                        <p><span>표준이하</span></p><p><span>표준</span></p><p><span>표준이상</span></p>
                        <div>
                            {percentBar(count)}
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
} 
export default memo((props) => {
    const sub = SUBS[0];
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    const [mainData, setMainData] = useState();
    const [wght, setWght] = useState(0);

    const [trgtValue, setTrgtValue] = useState({
        "wght":0,
        "vrtnType":"M",
        "rcntWght":0,
        "mainData":""
    });

    const request1402 = (trgtWght, vrtnType) => {
        PostApi1402(userinfo, cfg, phonecfg)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                setTrgtValue({
                    "wght":parseInt(trgtWght),
                    "vrtnType":vrtnType,
                    "rcntWght":parseInt(res.result.wght),
                    "mainData":res.result
                });
                $("#rcntBmi").text(res.result.wght+"kg");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const request1406 = () => {
        PostApi1406(userinfo, cfg, phonecfg)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                if(res.result.trgtWght === "9999") {
                    $("#trgtWght").val("미등록");
                } else {
                    $("#trgtWght").val(res.result.trgtWght);
                }

                if(res.result.vrtnType == "P") {
                    $("#vrtnType").prop("checked", true);
                } else {
                    $("#vrtnType").prop("checked", false);
                }
                
                request1402(res.result.trgtWght, res.result.vrtnType);
            } else {
                request1402("미등록", "M");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const trgtValueHandler = (wght, vrtnType) => {
        setTrgtValue({
            "wght":wght,
            "vrtnType":vrtnType
        });
    }

    useEffect(()=>{
        if(userinfo.userToken) {
            // request1402();
            request1406();
        } else {
            openAlertPopup("로그인 정보가 만료되었습니다.");
            _O.OpenMenu("/membership/login");
        }
    }, []);

    useEffect(() => {
        /////// 원형 프로그레스바 설정 - 세팅 보류...
        //var maxNum = 10000; //목표걸음수
        //var stNum = 3544; //남은걸음수
        //var alNum = (1 / maxNum) * (maxNum - stNum);

        $('.incircle').circleProgress({
            animation: false,
            startAngle: -Math.PI / 2,
            value: 1, 
            size:400,
            thickness:35,
            lineCap: 'round',
            fill: {
                gradient: ["#84d8c9", "#a6ace4"]
            }
        }).on('circle-animation-progress', function(event, progress, stepValue) {
            //$(".progress-circle p").html( Math.round(maxNum - (stepValue * maxNum)) );
            //$(".progress-circle em").html(maxNum);
        });

        $(".incircle canvas").removeAttr("style");
    }, []);

    useEffect(()=>{
        userHabit(phonecfg, 'BM110');
        NativeAction(phonecfg, "statusColor", "#7FD2C2");
    }, [phonecfg.version])

    return(
        <Fragment>
            <Container Title='몸무게 입력' goToUrl="/sm">
                <div className="contents sub">
                    <SubMenu code={sub.code} />

                    <div className="sub-contents">
                        <div className="exercise-walk-area">
                            <div className="incont-area bmi-myweight">
                                <div className="title">
                                    <p>나의 몸무게</p>
                                </div>

                                {/* 우측상단 원형 - 도전중 */}
                                
                                <ChallengeStatus nowBmi={trgtValue.rcntWght} trgtBmi={trgtValue.wght} vrtnType={trgtValue.vrtnType} />

                                <div className="progress-circle">
                                    <div className="incircle">
                                        <div className="info">
                                            <p id="rcntBmi"></p>
                                            <u className="en">Total Weight</u>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="btns-area">
                                    <a onClick={()=>_O.Open("/sm/bmi/input")}>몸무게 입력</a>
                                    <a className="open-target-weight">목표 몸무게</a>
                                </div>

                            </div>

                            {/* <div className="analysis-boxes-area">
                                <AnalyzeBox title="골격근/지방분석" />
                                <div className="box">
                                    <div className="tit">골격근/지방 분석</div>
                                    <div className="inlist-box">
                                        <ul>
                                            <li className="c-bl">
                                                <div className="le-sjt">
                                                    <i></i>
                                                    <span>BMI</span>
                                                    <p><b>21.6</b> kg/㎡</p>
                                                </div>
                                                <div className="cont-boxdots">
                                                    <div className="boxes-horizon">
                                                        <div className="bx-area">
                                                            <p><span>표준이하</span></p><p><span>표준</span></p><p><span>표준이상</span></p>
                                                            <div>
                                                                <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="c-rp">
                                                <div className="le-sjt">
                                                    <i></i>
                                                    <span>체지방률</span>
                                                    <p><b>25.8</b> %</p>
                                                </div>
                                                <div className="cont-boxdots">
                                                    <div className="boxes-horizon">
                                                        <div className="bx-area">
                                                            <p><span>표준이하</span></p><p><span>표준</span></p><p><span>표준이상</span></p>
                                                            <div>
                                                                <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                                <div className="box">
                                    <div className="tit">내장지방 분석</div>
                                    <div className="inlist-box">
                                        <ul>
                                            <li className="c-or">
                                                <div className="le-sjt">
                                                    <i></i>
                                                    <span>내장지방레벨</span>
                                                    <p><b>6</b> Level</p>
                                                </div>
                                                <div className="cont-boxdots">
                                                    <div className="boxes-horizon">
                                                        <div className="bx-area">
                                                            <p><span>표준이하</span></p><p><span>표준</span></p><p><span>표준이상</span></p>
                                                            <div>
                                                                <i></i><i></i><i></i><i></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>
            </Container>
            {/* <TargetWeight trgtWght={trgtWght} setTrgtWght={setTrgtWght} vrtnType={vrtnType} /> */}
            <TargetWeight trgtValue={trgtValue} trgtValueHandler={trgtValueHandler} />
            <AlertPopup />
        </Fragment>
    )
})

const ChallengeStatus = memo((props) => {
    const { nowBmi, trgtBmi, vrtnType } = props;

    return(
        <Fragment>
            {
                vrtnType === 'M'
                    ?   (nowBmi > trgtBmi)
                        ?  <div className="circle-right fa">
                                <div>
                                    목표몸무게
                                    <p><b>도전중!</b></p>
                                </div>
                            </div> 
                        :   <div className="circle-right su">
                                <div>
                                    목표몸무게
                                    <p><b>성공!</b></p>
                                </div>
                            </div>

                    :   (nowBmi < trgtBmi)
                        ?  <div className="circle-right fa">
                                <div>
                                    목표몸무게
                                    <p><b>도전중!</b></p>
                                </div>
                            </div> 
                        :   <div className="circle-right su">
                                <div>
                                    목표몸무게
                                    <p><b>성공!</b></p>
                                </div>
                            </div>
            }
        </Fragment>
    );
})

// export const TargetWght = () => {
//     return (
//         <div className="blacklayer-container target-weight-layer">
//             <div className="bl-blind"></div>
//             <div className="in-layerarea nobtn">
//                 <div className="blgrn-box vertical">
//                     <div className="blgr-title undcap">
//                         목표 몸무게 설정
//                         <p>
//                             담당 의사와 상담한 목표 몸무게 수치입니다.<br/>
//                             (미 설정시 키에 따른 표준 몸무게를 목표 몸무게로 설정합니다.)
//                         </p>
//                     </div>

//                     <div className="target-setting-box">
//                         <div className="inly-sutit">목표 몸무게</div>
//                         <div className="inly-backword">
//                             <i>kg</i>
//                             <input type="text" className="textbox bld" defaultValue="50" />
//                         </div>
//                     </div>

//                     <div className="tbns-area">
//                         <a className="btn-round gray">취소</a>
//                         <a className="btn-round wht">확인</a>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }